import { render, staticRenderFns } from "./AnimalMovements.vue?vue&type=template&id=435a0402"
import script from "./AnimalMovements.vue?vue&type=script&lang=ts"
export * from "./AnimalMovements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports